import { Space, Table, Tag, Popover, message } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useNavigate } from "react-router-dom";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import "./users.css";
import { Dispatch, SetStateAction, useState, useEffect } from "react";
import { deleteUser, getUserById } from "../../api/users";
import LockResetIcon from "@mui/icons-material/LockReset";
import { Password } from "../UI/User-Password/Changepassword";
import { useTranslation } from "react-i18next";
import EditButton from "../UI/EditButton/editbutton";
import DeleteButton from "../UI/DeleteButton/deletebutton";
import DeleteModal from "../UI/ModalComponent/DeleteModal/deletemodal";
import { AxiosResponse } from "axios";
interface UsersListProps {
  data: [];
  loading: boolean;
  getUsersMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      search: string;
      page: number;
    },
    unknown
  >;
  tableKey: number;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
}
interface UsersInterface {
  id: string;
  email: string;
  fullName: string;
  userName: string;
  isActive: boolean;
  role: string;
}
export const UsersList = ({
  data: users,
  loading,
  getUsersMutation,
  tableKey,
  page,
  setPage,
}: UsersListProps) => {
  const [openpassword, setOpenpassword] = useState(false);
  const [show] = useState(false);
  const [id, setId] = useState<number | undefined>();
  const navigate = useNavigate();
  const [t] = useTranslation("common");
  const [, setError] = useState("");

  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);
  const [nameToDelete, setNameToDelete] = useState<any>();
  const DeleteUser = (id: string | undefined, fullName: string): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(fullName);
  };

  useEffect(() => {
    getUsersMutation({
      search: "",
      page: page,
    });
  }, [getUsersMutation, page]);

  const handleOk = () => {
    if (idToDelete) {
      deleteUserMutation.mutate({ id: idToDelete });
    }
    setOpen(false);
  };

  const onError = (error: any, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };
  const deleteUserMutation = useMutation("deleteUser", deleteUser, {
    onSuccess: () => {
      getUsersMutation({
        search: "",
        page: page,
      });
      message.success("Complete successfully");
    },
    onError,
  });

  const getUserMutation = useMutation("getUser", getUserById, {});
  const pass = <div>{t("change-password")}</div>;

  const columns: ColumnsType<UsersInterface> = [
    {
      title: `${t("name")}`,
      dataIndex: "fullName",
      key: "fullName",
      className: "table-header",
      width: "30rem",
    },
    {
      title: `${t("email")}`,
      dataIndex: "email",
      key: "email",
    },

    {
      title: `${t("role")}`,
      dataIndex: "role",
      key: "role",
      width: "12rem",
      render: (record) => {
        return record.name;
      },
    },
    {
      title: `${t("status")}`,
      dataIndex: "isActive",
      key: "isActive",
      width: "5rem",
      align: "center" as "center",
      render: (record: any) =>
        record ? (
          <Tag className="active">Active</Tag>
        ) : (
          <Tag className="inactive">Inactive</Tag>
        ),
    },
    {
      title: `${t("action")}`,
      key: "action",
      width: "6rem",
      fixed: "right",
      align: "center" as "center",
      render: (record) => (
        <Space>
          <div style={{ display: "flex", alignItems: "center" }}>
            <EditButton
              onClick={() => {
                getUserMutation.mutateAsync(record.id).then((res) => {
                  navigate(`/users/${record.id}`, {
                    state: {
                      ...res.data,
                    },
                  });
                });
              }}
            />

            <Popover content={pass} mouseEnterDelay={0} mouseLeaveDelay={0}>
              <LockResetIcon
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  color: "#212121",
                }}
                onClick={() => {
                  setId(record.id);
                  setOpenpassword(true);
                }}
              />
            </Popover>
            <DeleteButton
              onClick={() => {
                DeleteUser(record?.id, record?.fullName);
              }}
            />
          </div>
        </Space>
      ),
    },
  ];
  return (
    <>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={nameToDelete}
        onOk={handleOk}
      />
      <Table
        scroll={{ x: 1000 }}
        key={tableKey}
        className="users-list"
        columns={columns}
        loading={loading}
        dataSource={users}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        onChange={(selectedPage) => {
          setPage(selectedPage.current || 1);
        }}
        pagination={{ pageSize: 10 }}
      />
      <Password
        openpassword={openpassword}
        setOpenpassword={setOpenpassword}
        show={show}
        id={id}
        requireOldPassword={false}
      />
    </>
  );
};
